import { admin, admin2 } from '@/api/instance'

const config = (shopId) => {
  return `/${shopId}/appointmentConfig`
}

const reservation = (shopId) => {
  return `/${shopId}/appointmentReservation`
}

//= > 預約參數設置
export const UpdateReservationParameter = async ({
  shopId,
  timeUnit,
  timeUnitOffset,
  minReservationInterval,
  maxReservationInterval,
  cancelInterval,
  enableCancelReasonCollection,
  useNotSpecify,
  notSpecifySkipUnit,
  notSpecifyImage,
  notSpecifyName,
  notSpecifyRule,
  notSpecifyUnits,
  pageStyle,
  pageText,
  allowOrderMorePeople,
  maxOrderMorePeopleCount,
  allowOtherReservation,
  secondOrderStartClientChange,
  secondOrderStartDefault,
  orderServiceAttachClientCheck,
  orderServiceAttachClientNullOption,
  orderServiceAttachClientNullOptionPosition,
  orderServiceAttachClientMultipleSelection,
  enableUserAddress,
  notSpecifyOrderRule,
  chargeType,
  allowBatchOrder,
  clientOrderMode,
  batchOrderNotifyMode,
  enablePaymentIcon,
  enableClientCustomTimeSlots,
  clientCustomTimeSlots,
  enableTimeSlotMemo,
  timeSlotMemoSetting,
  userCommentSetting,
  enableClassTicket,
  adminQuickPaymentUrl,
  // 預約回覆設定
  enableReply,
  replyStartConfig,
  replyEndConfig,
  enableNoReplyAutoCancel,
  noReplyAutoCancelConfig,
  noReplyAutoCancelText,
}) => {
  return await admin2({
    method: 'PUT',
    url: `${config(shopId)}`,
    data: {
      timeUnit,
      timeUnitOffset,
      minReservationInterval,
      maxReservationInterval,
      cancelInterval,
      enableCancelReasonCollection,
      useNotSpecify,
      notSpecifySkipUnit,
      notSpecifyImage,
      notSpecifyName,
      notSpecifyRule,
      notSpecifyUnits,
      pageStyle,
      pageText,
      allowOrderMorePeople,
      maxOrderMorePeopleCount,
      allowOtherReservation,
      secondOrderStartClientChange,
      secondOrderStartDefault,
      orderServiceAttachClientCheck,
      orderServiceAttachClientNullOption,
      orderServiceAttachClientNullOptionPosition,
      orderServiceAttachClientMultipleSelection,
      enableUserAddress,
      notSpecifyOrderRule,
      chargeType,
      allowBatchOrder,
      clientOrderMode,
      batchOrderNotifyMode,
      enablePaymentIcon,
      enableClientCustomTimeSlots,
      clientCustomTimeSlots,
      enableTimeSlotMemo,
      timeSlotMemoSetting,
      userCommentSetting,
      enableClassTicket,
      adminQuickPaymentUrl,
      // 預約回覆設定
      enableReply,
      replyStartConfig,
      replyEndConfig,
      enableNoReplyAutoCancel,
      noReplyAutoCancelConfig,
      noReplyAutoCancelText,
    },
  })
}

//= > 查找店家預約參數
export const FindReservationParameter = async ({ shopId }) => {
  const res = await admin({
    method: 'get',
    url: `${config(shopId)}`,
  })

  return res.data
}

//= > 預約創建
export const CreateReservation = async ({
  shopId,
  appointmentUnitId,
  appointmentServiceId,
  appointmentServiceAttachIds,
  start,
  totalBookingTime,
  userName,
  userPhone,
  userComment,
  remark,
  memberId,
  overtime,
}) => {
  const res = await admin({
    method: 'post',
    url: `${reservation(shopId)}`,
    data: {
      appointmentUnitId,
      appointmentServiceId,
      appointmentServiceAttachIds,
      start,
      totalBookingTime,
      userName,
      userPhone,
      userComment,
      remark,
      memberId,
      overtime,
    },
  })

  return res.data
}

//= > 取得預約
export const GetReservation = async ({
  shopId,
  dateStart,
  dateEnd,
  start,
  limit,
  sort,
  sortBy,
  code,
  search,
  MemberId,
  AppointmentUnitId,
  AppointmentServiceId,
  AppointmentCategoryId,
  ResourceItemId,
  resourceItemCategoryIds,
  includeAppointmentOrderCheckIn,
  includeAppointmentReservationTicket,
  includeCustomFlowRecord,
  includeAppointmentOrderDeposit,
  includeAppointmentCheckoutOrder,
  includeSignatureMapping,
  customFlowNodeId,
  status,
  replyStatus,
  cancelReasonCode,
}) => {
  const res = await admin({
    method: 'get',
    url: `${reservation(shopId)}`,
    params: {
      dateStart,
      dateEnd,
      start,
      limit,
      sort,
      sortBy,
      code,
      search,
      MemberId,
      AppointmentUnitId,
      AppointmentServiceId,
      AppointmentCategoryId,
      ResourceItemId,
      resourceItemCategoryIds,
      includeAppointmentOrderCheckIn,
      includeAppointmentReservationTicket,
      includeCustomFlowRecord,
      includeAppointmentOrderDeposit,
      includeAppointmentCheckoutOrder,
      includeSignatureMapping,
      customFlowNodeId,
      status,
      replyStatus,
      cancelReasonCode,
    },
  })

  return res.data
}

export const GetReservationSimple = async ({
  limit,
  start,
  sort,
  sortBy,
  shopId,
  search,
  ResourceItemId,
  resourceItemCategoryIds,
  dateStart,
  dateEnd,
  AppointmentUnitId,
  AppointmentServiceId,
  code,
}) => {
  return await admin2({
    url: `${reservation(shopId)}/simpleFind`,
    params: {
      limit,
      start,
      sort,
      sortBy,
      search,
      ResourceItemId,
      resourceItemCategoryIds,
      dateStart,
      dateEnd,
      AppointmentUnitId,
      AppointmentServiceId,
      code,
    },
  })
}

//= > 取得預約總數
export const GetReservationCount = async ({
  shopId,
  dateStart,
  dateEnd,
  code,
  search,
  MemberId,
  AppointmentUnitId,
  AppointmentServiceId,
  AppointmentCategoryId,
  ResourceItemId,
  resourceItemCategoryIds,
  customFlowNodeId,
  status,
  replyStatus,
  cancelReasonCode,
}) => {
  const res = await admin({
    method: 'get',
    url: `${reservation(shopId)}/count`,
    params: {
      dateStart,
      dateEnd,
      code,
      search,
      MemberId,
      AppointmentUnitId,
      AppointmentServiceId,
      AppointmentCategoryId,
      ResourceItemId,
      resourceItemCategoryIds,
      customFlowNodeId,
      status,
      replyStatus,
      cancelReasonCode,
    },
  })

  return res.data.count
}

//= > 查找預約
export const FindReservation = async ({
  shopId,
  id,
  includeCustomFlowRecord,
  includeAppointmentVisitorPreOrder,
  includeSignatureMapping,
}) => {
  const res = await admin({
    method: 'get',
    url: `${reservation(shopId)}/${id}`,
    params: {
      includeCustomFlowRecord,
      includeAppointmentVisitorPreOrder,
      includeSignatureMapping,
    },
  })

  return res.data
}

//= > 更新預約資訊
export const UpdateReservationInfo = async ({
  shopId,
  id,
  userName,
  userPhone,
  userComment,
  remark,
}) => {
  return await admin2({
    method: 'put',
    url: `${reservation(shopId)}/${id}/info`,
    data: {
      userName,
      userPhone,
      userComment,
      remark,
    },
  })
}

//= > 更新預約時間與服務
export const UpdateReservationTimeServices = async ({
  shopId,
  id,
  start,
  resourceItemId,
  appointmentUnitId,
  appointmentServiceId,
  appointmentSubServiceId,
  appointmentServiceAttachIds,
  totalBookingTime,
  resourceItemTotalBookingTime,
  overtime,
}) => {
  return await admin2({
    method: 'PUT',
    url: `${reservation(shopId)}/${id}/time`,
    data: {
      start,
      resourceItemId,
      appointmentUnitId,
      appointmentServiceId,
      appointmentSubServiceId,
      appointmentServiceAttachIds,
      totalBookingTime,
      resourceItemTotalBookingTime,
      overtime,
    },
  })
}

//= > 更新預約狀態
export const UpdateReservationStatus = async ({ shopId, id, status }) => {
  const res = await admin({
    method: 'put',
    url: `${reservation(shopId)}/${id}/status`,
    data: {
      status,
    },
  })

  return res.data
}

//= > 取得預約次數，可過濾狀態
/**
 *  reservationStatus: {
 *    已預約: 'wait',
 *    完成: 'complete',
 *    未到: 'absence',
 *    取消: 'cancel',
 *  },
 */
export const GetReservationCountByStatus = async ({ shopId, MemberId, status }) => {
  const res = await admin({
    method: 'GET',
    url: `${reservation(shopId)}/count`,
    params: {
      MemberId,
      status,
    },
  })
  return res.data
}

//  Reservation Order 預約訂單 NEW
export const CreateReservationOrder = async ({
  shopId,
  reservations,
  userType,
  memberId,
  userName,
  userPhone,
  userComment,
  adminComment,
  peopleCount,
  depositPrice,
  depositPaidType,
  depositPaidTypeComment,
  // remark,
  customCreationInfo,
}) => {
  const res = await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder`,
    data: {
      reservations,
      userType,
      memberId,
      userName,
      userPhone,
      peopleCount,
      userComment,
      adminComment,
      depositPrice,
      depositPaidType,
      depositPaidTypeComment,
      // remark,
      customCreationInfo,
    },
  })

  return res
}

//  Reservation Order smartCreate
export const SmartCreateReservationOrder = async ({
  shopId,
  reservations,
  userType,
  memberId,
  userName,
  userPhone,
  userComment,
  adminComment,
  peopleCount,
  depositPrice,
  depositPaidType,
  depositPaidTypeComment,
  checkoutPrice,
  checkoutPaidType,
  checkoutPaidTypeComment,
  checkoutInvoiceInfo,
  cashbackDeductionAmount,
  customCreationInfo,
}) => {
  const res = await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/smartCreate`,
    data: {
      reservations,
      userType,
      memberId,
      userName,
      userPhone,
      peopleCount,
      userComment,
      adminComment,
      depositPrice,
      depositPaidType,
      depositPaidTypeComment,
      checkoutPrice,
      checkoutPaidType,
      checkoutPaidTypeComment,
      checkoutInvoiceInfo,
      cashbackDeductionAmount,
      customCreationInfo,
    },
  })

  return res
}

export const GetReservationOrder = async ({ shopId, start, limit, dateStart, dateEnd }) => {
  const res = await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrder`,
    params: {
      start,
      limit,
      dateStart,
      dateEnd,
    },
  })

  return res
}

export const GetReservationOrderCount = async ({
  shopId,
  MemberId,
  dateStart,
  dateEnd,
  code,
  userName,
  AppointmentUnitId,
  AppointmentServiceId,
}) => {
  const res = await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrder/count`,
    params: {
      MemberId,
      dateStart,
      dateEnd,
      code,
      userName,
      AppointmentUnitId,
      AppointmentServiceId,
    },
  })

  return res
}

export const FindReservationOrder = async ({ shopId, id }) => {
  const res = await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrder/${id}`,
  })

  return res
}

export const UpdateReservationOrderStatus = async ({ shopId, id, status, cancelReasonCode, cancelReasonNote }) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentOrder/${id}/status`,
    data: {
      status,
      cancelReasonCode,
      cancelReasonNote,
    },
  })
}

/**
 * 更新預約訂單回覆狀態
 * admin.appointmentOrder.updateReplyStatus
 * @param {Object} param0
 * @param {String} param0.shopId 店家 ID
 * @param {String} param0.id 預約訂單 ID
 * @param {'pending' | 'replied' | 'expired' | 'no_reply_needed'} param0.replyStatus 預約回覆狀態
 * @returns
 */
export const UpdateReservationOrderReplyStatus = async ({ shopId, id, replyStatus }) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentOrder/${id}/replyStatus`,
    data: {
      replyStatus,
    },
  })
}

export const UpdateReservationOrderInfo = async ({
  shopId,
  id,
  userName,
  userPhone,
  userComment,
  userAddress,
  adminComment,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentOrder/${id}/info`,
    data: {
      userName,
      userPhone,
      userComment,
      userAddress,
      adminComment,
    },
  })
}

export const OrderDepositRefund = async ({
  shopId,
  id,
  refundType,
  refundTypeComment,
  refundPrice,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/${id}/depositRefund`,
    data: {
      refundType,
      refundTypeComment,
      refundPrice,
    },
  })
}

export const OrderCheckoutRefund = async ({
  shopId,
  id,
  refundType,
  refundTypeComment,
  refundPrice,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/${id}/checkoutRefund`,
    data: {
      refundType,
      refundTypeComment,
      refundPrice,
    },
  })
}

export const UpdateAppointmentHomePage = async ({ shopId, id, enable, title, content, images }) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentHomePage`,
    data: {
      enable,
      title,
      content,
      images,
    },
  })
}

export const GetAppointmentHomePage = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentHomePage`,
  })
}

export const UpdateAppointmentCreatePromptPage = async ({ shopId, enable, title, content }) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentCreatePromptPage`,
    data: {
      enable,
      title,
      content,
    },
  })
}

export const GetAppointmentCreatePromptPage = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCreatePromptPage`,
  })
}

export const GetAvailableTimes = async ({
  shopId,
  rangeStart,
  rangeEnd,
  appointmentUnitIds,
  resourceItemIds,
  appointmentServiceId,
  appointmentSubServiceId,
  appointmentServiceAttachIds,
  peopleCount,
  preReservations,
  omitOhbookBookingIds,
  setTotalBookingTime,
  setResourceItemTotalBookingTime,
  signal,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/availableTimes`,
    signal,
    data: {
      rangeStart,
      rangeEnd,
      appointmentUnitIds,
      resourceItemIds,
      appointmentServiceId,
      appointmentSubServiceId,
      appointmentServiceAttachIds,
      peopleCount,
      preReservations,
      omitOhbookBookingIds,
      setTotalBookingTime,
      setResourceItemTotalBookingTime,
    },
  })
}

export const CheckReservation = async ({
  shopId,
  start,
  resourceItemIds,
  appointmentUnitIds,
  appointmentServiceId,
  appointmentSubServiceId,
  appointmentServiceAttachIds,
  useNotSpecifyRule,
  peopleCount,
  preReservations,
  omitOhbookBookingIds,
  setTotalBookingTime,
  setResourceItemTotalBookingTime,
  isOvertime,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/preDetailByStart`,
    data: {
      start,
      resourceItemIds,
      appointmentUnitIds,
      appointmentServiceId,
      appointmentSubServiceId,
      appointmentServiceAttachIds,
      useNotSpecifyRule,
      peopleCount,
      preReservations,
      omitOhbookBookingIds,
      setTotalBookingTime,
      setResourceItemTotalBookingTime,
      isOvertime,
    },
  })
}

/**
 * 取得預約訂單的歷史事件記錄
 *
 * 對應後端 API: admin.appointmentOrder.findEvents
 *
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 店家 ID
 * @param {string} params.orderId - 訂單 ID
 * @param {string} [params.reservationId] - 目前檢視的預約記錄 ID
 * @param {number} [params.start] - 分頁起始位置
 * @param {number} [params.limit] - 每頁筆數
 *
 * @returns {Promise<[AppointmentOrderEvent[], string|null]>} 訂單事件列表
 *
 * @typedef {Object} AppointmentOrderEvent
 * @property {string} id - 事件 ID
 * @property {'confirm'|'wait'|'cancel'|'complete'|'absence'|'paid'|'paidFailed'|'paidExpired'|'paidWaitRefund'|'paidRefund'|'replyPending'|'replyReplied'|'replyExpired'|'replyNoReplyNeeded'} type - 事件類型
 * @property {'system'|'admin'|'client'} source - 事件來源（系統/後台/客戶）
 * @property {Object|null} data - 事件資料
 * @property {string} createdAt - 建立時間 (ISO 8601)
 * @property {string} updatedAt - 更新時間 (ISO 8601)
 * @property {string|null} ShopId - 店家 ID
 * @property {string|null} UserId - 使用者 ID（當 source 為 'admin' 時）
 * @property {string|null} MemberId - 會員 ID（當 source 為 'client' 時）
 * @property {string|null} AppointmentOrderId - 預約訂單 ID
 * @property {Object|null} User - 操作者資訊（當 source 為 'admin' 時包含操作者資料）
 * @property {string} User.id - 操作者 ID
 * @property {string|null} User.name - 操作者名稱
 * @property {Object|null} Member - 會員資訊（當 source 為 'client' 時包含會員資料）
 * @property {string} Member.id - 會員 ID
 * @property {Object|null} Member.UserInfo - 會員使用者資訊
 * @property {string|null} Member.UserInfo.name - 會員名稱
 *
 * @example
 * // 取得訂單歷史記錄
 * const events = await FindReservationOrderHistory({
 *   shopId: 'shop_123',
 *   orderId: 'order_456',
 *   start: 0,
 *   limit: 20
 * })
 *
 * // 回應範例（當來源為後台時）
 * // [
 * //   {
 * //     "id": "evt_123",
 * //     "type": "cancel",
 * //     "source": "admin",
 * //     "updatedAt": "2025-10-03T10:00:00Z",
 * //     "User": {
 * //       "id": "user_abc",
 * //       "name": "AdminUser"
 * //     },
 * //     "Member": null
 * //   }
 * // ]
 *
 * // 回應範例（當來源為客戶時）
 * // [
 * //   {
 * //     "id": "evt_124",
 * //     "type": "wait",
 * //     "source": "client",
 * //     "updatedAt": "2025-10-03T09:00:00Z",
 * //     "User": null,
 * //     "Member": {
 * //       "id": "mem_xyz",
 * //       "UserInfo": {
 * //         "name": "CustomerName"
 * //       }
 * //     }
 * //   }
 * // ]
 */
export const FindReservationOrderHistory = async ({ shopId, orderId, reservationId, start, limit }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentOrder/${orderId}/events`,
    params: {
      reservationId,
      start,
      limit,
    },
  })
}

// checkout 預約結帳 api

export const GetReservationCheckoutConfig = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCheckoutConfig`,
  })
}

// update checkout config
export const UpdateReservationCheckoutConfig = async ({
  shopId, freeMemberConfig,
  enableCashbackDeduction,
  cashbackDeductionPercent,
  enableServiceAttachCashbackDeduction,
  paymentDeadlineMinute,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentCheckoutConfig`,
    data: {
      freeMemberConfig,
      enableCashbackDeduction,
      cashbackDeductionPercent,
      enableServiceAttachCashbackDeduction,
      paymentDeadlineMinute,
    },
  })
}

export const GetReservationCheckoutPaymentConfig = async ({ shopId, start, limit }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCheckoutPaymentConfig`,
    params: {
      start,
      limit,
    },
  })
}

// get config by count
export const GetReservationCheckoutPaymentConfigCount = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCheckoutPaymentConfig/count`,
  })
}

// find payment by id
export const FindReservationCheckoutPaymentConfig = async ({ shopId, id }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCheckoutPaymentConfig/${id}`,
  })
}

// create payment
export const CreateReservationCheckoutPaymentConfig = async ({ shopId, type, enable, config }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/appointmentCheckoutPaymentConfig`,
    data: {
      type,
      enable,
      config,
    },
  })
}

// delete payment by id
export const DeleteReservationCheckoutPaymentConfig = async ({ shopId, id }) => {
  return admin2({
    method: 'DELETE',
    url: `/${shopId}/appointmentCheckoutPaymentConfig/${id}`,
  })
}

// update payment by id
export const UpdateReservationCheckoutPaymentConfig = async ({ shopId, id, enable }) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentCheckoutPaymentConfig/${id}`,
    data: {
      enable,
    },
  })
}

// get checkout invoice config
export const GetReservationCheckoutInvoiceConfig = async ({ shopId }) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentCheckoutInvoiceConfig`,
  })
}

// update checkout invoice config
export const UpdateReservationCheckoutInvoiceConfig = async ({
  shopId,
  enable,
  platform,
  invoiceApiConfig,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentCheckoutInvoiceConfig`,
    data: {
      enable,
      platform,
      invoiceApiConfig,
    },
  })
}

export const UpdateReservationCheckoutInvoiceStatus = async ({ shopId, id, invoiceStatus }) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/appointmentCheckoutOrder/${id}/invoiceStatus`,
    data: {
      invoiceStatus,
    },
  })
}

export const ReservationOrderCalculateCheckoutPrice = async ({
  shopId,
  memberId,
  reservations,
  cashbackDeductionAmount,
  customCreationInfo,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/calculateCheckoutPrice`,
    data: {
      memberId,
      reservations,
      cashbackDeductionAmount,
      customCreationInfo,
    },
  })
}

export const CalculateCheckoutCashbackLimit = async ({
  memberId,
  reservations,
  shopId,
  customCreationInfo,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/calculateCheckoutCashbackDeductionLimit`,
    data: {
      memberId,
      reservations,
      customCreationInfo,
    },
  })
}

export const FindAppointmentBatchOrder = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/appointmentBatchOrder/${id}`,
  })
}

// appointmentOrder V2

/**
 * 建立預約單 V2 admin.appointment.v2Create
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {Array} params.reservations - 預約項目列表
 * @param {string} params.userType - 使用者類型
 * @param {string} [params.memberId] - 會員 ID
 * @param {string} [params.userName] - 使用者姓名
 * @param {string} [params.userPhone] - 使用者電話
 * @param {string} [params.userComment] - 使用者備註
 * @param {string} [params.adminComment] - 管理者備註
 * @param {number} [params.peopleCount] - 人數
 * @param {string} [params.chargeType] - 收費類型
 * @param {string} [params.paymentCode] - 付款代碼
 * @param {number} [params.paymentPrice] - 付款金額
 * @param {string} [params.paymentComment] - 付款備註
 * @param {number} [params.cashbackDeductionAmount] - 折抵金額
 * @param {Object} [params.invoiceInfo] - 發票資訊
 * @param {string[]} [params.signatureRecordIds] - 簽名記錄 ID 列表
 * @param {Object} [params.customCreationInfo] - 自訂建立資訊
 * @returns {Promise} 建立結果
 */
export const CreateAppointmentOrderV2 = async ({
  shopId,
  reservations,
  userType,
  memberId,
  userName,
  userPhone,
  userComment,
  adminComment,
  peopleCount,
  chargeType,
  paymentCode,
  paymentPrice,
  paymentComment,
  cashbackDeductionAmount,
  invoiceInfo,
  signatureRecordIds,
  customCreationInfo,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/v2`,
    data: {
      reservations,
      userType,
      memberId,
      userName,
      userPhone,
      userComment,
      adminComment,
      peopleCount,
      chargeType,
      paymentCode,
      paymentPrice,
      paymentComment,
      cashbackDeductionAmount,
      invoiceInfo,
      signatureRecordIds,
      customCreationInfo,
    },
  })
}

/**
 * @typedef {Object} BatchAppointmentReservation
 * @property {string} appointmentServiceId - 服務 ID
 * @property {string[]} appointmentServiceAttachIds - 附加服務 ID 陣列
 * @property {string} start - 預約開始時間 (ISO 8601)
 * @property {string} [appointmentUnitId] - 服務人員 ID
 * @property {string} [resourceItemId] - 設備項目 ID
 * @property {string} [appointmentSubServiceId] - 子服務 ID
 * @property {string} [classTicketRecordId] - 預扣堂票記錄 ID
 * @property {string} [userName] - 服務顧客姓名
 * @property {string} [userPhone] - 服務顧客電話
 * @property {boolean} [isOvertime] - 是否為加班
 * @property {boolean} [isOther] - 是否為額外預約記錄（非第一筆）
 * @property {boolean} [fromNotSpecify] - 是否為不指定服務人員預約
 * @property {boolean} [resourceItemAutoAssign] - 是否自動分配設備項目
 * @property {number} [setTotalBookingTime] - 預約庫存佔用時間（分鐘）
 * @property {number} [setResourceItemTotalBookingTime] - 設備項目庫存佔用時間（分鐘）
 */

/**
 * @typedef {Object} BatchAppointmentOrder
 * @property {BatchAppointmentReservation[]} reservations - 預約紀錄（1–10 筆）
 * @property {number} [peopleCount=1] - 預約人數
 * @property {string[]} [signatureRecordIds] - 簽名紀錄 ID 陣列
 */

/**
 * 批次建立預約單 V2 admin.appointmentOrder.batchCreateV2
 * @param {Object} params
 * @param {string} params.shopId - 店家 ID
 * @param {BatchAppointmentOrder[]} params.orders - 預約單列表（1–15 筆）
 * @param {string} params.userType - 使用者類型 (member|guest|true|visitor)
 * @param {string} [params.memberId] - 會員 ID
 * @param {string} [params.userName] - 預約人姓名
 * @param {string} [params.userPhone] - 預約人電話
 * @param {string} [params.userComment] - 預約人備註
 * @param {string} [params.adminComment] - 後台備註
 * @param {string} [params.chargeType] - 收費類型 (none|deposit|checkout)
 * @param {string} [params.paymentCode] - 付款方式代碼
 * @param {number} [params.paymentPrice] - 付款金額
 * @param {string} [params.paymentComment] - 付款備註
 * @param {string} [params.paymentEmail] - 付款人 Email
 * @param {number} [params.cashbackDeductionAmount] - 使用回饋金折扣
 * @param {Object} [params.invoiceInfo] - 發票資訊
 * @param {Object} [params.customCreationInfo] - 自訂建立資訊
 * @returns {Promise} 建立結果
 */
export const CreateBatchAppointmentOrderV2 = async ({
  shopId,
  orders,
  userType,
  memberId,
  userName,
  userPhone,
  userComment,
  adminComment,
  chargeType,
  paymentCode,
  paymentPrice,
  paymentComment,
  paymentEmail,
  cashbackDeductionAmount,
  invoiceInfo,
  customCreationInfo,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/batchCreate/v2`,
    data: {
      orders,
      userType,
      memberId,
      userName,
      userPhone,
      userComment,
      adminComment,
      chargeType,
      paymentCode,
      paymentPrice,
      paymentComment,
      paymentEmail,
      cashbackDeductionAmount,
      invoiceInfo,
      customCreationInfo,
    },
  })
}

export const AppointmentOrderCalculateDetailV2 = async ({
  shopId,
  memberId,
  orders,
  cashbackDeductionAmount,
  customCreationInfo,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/calculateDetail/v2`,
    data: {
      memberId,
      orders,
      cashbackDeductionAmount,
      customCreationInfo,
    },
  })
}

export const AppointmentBatchOrderPaymentRefund = async ({
  shopId,
  id,
  refundType,
  refundTypeInfo,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentBatchOrder/${id}/paymentRefund`,
    data: {
      refundType,
      refundTypeInfo,
    },
  })
}

export const AppointmentCalculateItemizedDetails = async ({
  shopId,
  memberId,
  orders,
  cashbackDeductionAmount,
  customCreationInfo,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/appointmentOrder/calculateItemizedDetails`,
    data: {
      memberId,
      orders,
      cashbackDeductionAmount,
      customCreationInfo,
    },
  })
}

// admin.appointmentDebug.checkAvailability
export const CheckAppointmentTimeAvailability = async ({
  shopId,
  appointmentServiceId,
  appointmentSubServiceId,
  appointmentServiceAttachIds,
  appointmentUnitId,
  resourceItemId,
  startAt,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/appointmentDebug/checkAvailability`,
    data: {
      appointmentServiceId,
      appointmentSubServiceId,
      appointmentServiceAttachIds,
      appointmentUnitId,
      resourceItemId,
      startAt,
    },
  })
}
